// import external dependencies
import jquery from 'jquery';

declare global {
  interface Window {
    $: typeof jquery;
    jQuery: typeof jquery;
  }
}

window.$ = window.jQuery = jquery;

// import Modal from 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

// Modules

import './modules/sliders';
import './modules/header-buttons';
import './modules/share';
import './modules/aos';
import './modules/title';
import './modules/font-loader';
import './modules/menu-offcanvas';

// @ts-expect-error animation
import { initKeyNumbers } from './modules/numbers-animation';

document.addEventListener("DOMContentLoaded", () => {
  initKeyNumbers(".key-numbers-section");
});